<template>
  <div class="inner-dashboard">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      loader="dots"
      :opacity="1"
    />
    <PropertyDashboardSidebarNav
      v-if="!isLoading"
      :propertyId="propertyId"
      :campaignId="campaignId"
      :showLeadIntro="showLeadIntro"
      :showTopIntro="showTopIntro"
    />
    <div class="container h-100 pt-4" v-if="!isLoading">
      <div
        class="property-dashboard-content-heading row justify-content-between"
      >
        <div class="heading-text col-12 col-md-6 mb-0">
          <div class="current-property">
            <button
              class="navbar-toggler ms-auto d-inline d-lg-none"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasMenu"
              aria-controls="offcanvasMenu"
            >
              <font-awesome-icon icon="compass" />
            </button>
            {{ campaignName }}
          </div>
          <div class="current-route">
            Tenant Demographics
            <img
              src="@/assets/linkedin.png"
              style="height: 11px; width: 11px"
            />
          </div>
        </div>
        <div
          class="col-12 col-md-6 buttons d-flex justify-content-end"
          v-if="campaignName"
        >
          <button
            type="button"
            class="btn btn-primary wti-btn wti-btn-white share-button ms-4"
            @click="generatePDF"
            :disabled="isAllLoading"
          >
            <span
              v-if="isAllLoading"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            {{ isAllLoading ? "" : "Download PDF" }}
          </button>
        </div>
      </div>
      <div class="container">
        <div class="row row-cols-1 row-cols-lg-2 me-lg-4">
          <div class="col px-0 pe-lg-2">
            <div class="section top-section-container">
              <label class="col form-label">Most Viewed Industries</label>
              <div class="position-relative section-data-conatiner">
                <loading
                  v-model:active="isTopRecordsLoading"
                  :is-full-page="false"
                  loader="dots"
                  :opacity="1"
                />
                <Bar
                  v-if="!isTopRecordsLoading"
                  :data="topIndustriesChartData"
                  :options="chartOptions1"
                />
              </div>
            </div>
          </div>
          <div class="col px-0 ps-lg-2">
            <div class="section top-section-container">
              <label class="col form-label">Most Viewed Job Titles</label>
              <div class="position-relative section-data-conatiner">
                <loading
                  v-model:active="isTopRecordsLoading"
                  :is-full-page="false"
                  loader="dots"
                  :opacity="1"
                />
                <Bar
                  v-if="!isTopRecordsLoading"
                  :data="topJobTitlesChartData"
                  :options="chartOptions2"
                />
              </div>
            </div>
          </div>
          <div class="col px-0 pe-lg-2">
            <div class="section top-section-container mb-4">
              <label class="col form-label">Most Viewed Tenant Markets</label>
              <div class="position-relative section-data-conatiner">
                <loading
                  v-model:active="isTopRecordsLoading"
                  :is-full-page="false"
                  loader="dots"
                  :opacity="1"
                />
                <Bar
                  v-if="!isTopRecordsLoading"
                  :data="topRegionsChartData"
                  :options="chartOptions3"
                />
              </div>
            </div>
          </div>
          <div class="col px-0 ps-lg-2">
            <div class="section top-section-container mb-4">
              <label class="col form-label">Most Viewed Company Sizes</label>
              <div class="position-relative section-data-conatiner">
                <loading
                  v-model:active="isTopRecordsLoading"
                  :is-full-page="false"
                  loader="dots"
                  :opacity="1"
                />
                <Bar
                  v-if="!isTopRecordsLoading"
                  :data="topCompanySizesChartData"
                  :options="chartOptions4"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row me-lg-4">
          <div class="section position-relative companies-container">
            <div class="d-flex flex-column flex-md-row">
              <div class="flex-grow-1">
                <label class="form-label">Companies Reached</label>
              </div>
              <div
                class="date-range-picker text-end me-4 date-range-picker-channel position-relative"
              >
                <loading
                  v-model:active="isLoading"
                  :is-full-page="false"
                  loader="dots"
                  :opacity="1"
                />
                <VueDatePicker
                  v-model="dateRange"
                  range
                  multi-calendars
                  :min-date="campaignStartDate"
                  :max-date="yesterday"
                  :enable-time-picker="false"
                  ref="datepicker"
                >
                  <template #left-sidebar>
                    <div v-for="(val, key) in rangeTypes" :key="key">
                      <button
                        type="button"
                        class="btn"
                        :class="{ active: this.rangeType == key }"
                        @click="updateRange(key)"
                      >
                        {{ val }}
                      </button>
                    </div>
                  </template>
                </VueDatePicker>
              </div>
              <div class="text-end">
                <JsonCSV
                  :data="reachedCampaignsExport"
                  v-if="
                    !isCompaniesReachedLoading &&
                    reachedCampaignsExport.length > 0
                  "
                  :name="campaignName + '-Reached-Companies.csv'"
                  class="export-btn"
                >
                  <button class="btn btn-dark wti-btn-black">
                    Export to CSV
                  </button>
                </JsonCSV>
              </div>
            </div>
            <div class="position-relative section-data-conatiner">
              <loading
                v-model:active="isCompaniesReachedLoading"
                :is-full-page="false"
                loader="dots"
                :opacity="1"
              />
              <div class="companies-table-container">
                <DatatableComponent
                  v-if="!isCompaniesReachedLoading"
                  :data="companies"
                  :columns="columns"
                  :options="{
                    paging: false,
                    searching: false,
                    info: false,
                    responsive: true,
                    stripeClasss: [],
                    ordering: true,
                    order: [[3, 'desc']],
                    fixedHeader: true,
                    scrollY:
                      companies.length > 0
                        ? companies.length * 55 > 620
                          ? 620
                          : companies.length * 55
                        : 80,
                  }"
                  :keys="keys"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@use "@/assets/vars.sass" as *
@use 'datatables.net-bs5' as *

.section-data-conatiner
  min-height: 80px
.companies-table-container
  min-height: 30vh
  overflow-y: auto
  .datatable
    width: 98% !important
.top-section-container
  margin-bottom: 20px
  height: 210px
  .form-label
    margin-bottom: 0 !important
.top10-section-container
  height: 340px
.export-btn button
  font-weight: 600
  font-size: 14px
  line-height: 18px
  +mobile
    font-size: 12px
    border-radius: 0.375rem
.companies-container
  .form-label
    margin-bottom: 0 !important
</style>

<script>
import { ref } from "vue";
import api from "@/services/BackendConnection";
import PropertyDashboardSidebarNav from "@/components/PropertyDashboardSidebarNav.vue";
import DatatableComponent from "@/components/DatatableComponent.vue";
import JsonCSV from "vue-json-csv";
import mockData from "@/utils/mockData.json";
import moment from "moment";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  // LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Bar } from "vue-chartjs";
import chartjsPluginAnnotation from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  // LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  chartjsPluginAnnotation,
  ChartDataLabels
);

export default {
  name: "TenantDemographicsView",
  setup(props) {
    const isUrl = (str) => {
      const urlPattern = /^(https?:\/\/)[\w.-]+\.[a-zA-Z]{2,}(\/\S*)?$/;
      return urlPattern.test(str);
    };
    const getBaseChartOptions = () => ({
      indexAxis: "y",
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: true,
        },
        datalabels: {
          anchor: "end",
          align: "end",
          formatter: (value) =>
            value.toLocaleString(undefined, { maximumFractionDigits: 1 }),
          color: "#06152B",
          font: function (context) {
            var width = context.chart.width;
            var size = 14;
            if (Math.round(width / 32) < 14) {
              size = Math.round(width / 32);
            }
            return {
              weight: 600,
              size: size,
              family: "Sora",
            };
          },
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
          ticks: {
            display: false,
          },
          border: {
            display: false,
          },
        },
        y: {
          grid: {
            display: false,
          },
          ticks: {
            crossAlign: "far",
            color: "#06152B",
            font: function (context) {
              return {
                size: 14,
                weight: 400,
                family: "Sora",
              };
            },
            callback: function (value, index, values) {
              const chartWidth = this.chart.width;
              const estimatedCharWidth = 14;
              const maxLabelLength = Math.floor(
                chartWidth / estimatedCharWidth / 1.5
              );
              let label = this.chart.data.labels[index] || "";
              return label.length > maxLabelLength
                ? label.substring(0, maxLabelLength) + "..."
                : label;
            },
          },
          border: {
            display: false,
          },
        },
      },
      layout: {
        padding: {
          left: 0,
          right: 40,
        },
      },
      barThickness: 14,
    });
    const chartOptions1 = getBaseChartOptions();
    const chartOptions2 = getBaseChartOptions();
    const chartOptions3 = getBaseChartOptions();
    const chartOptions4 = getBaseChartOptions();

    var yesterday = moment().subtract(1, "days").toDate();
    const datepicker = ref(null);
    return {
      campaignName: ref(null),
      isCompaniesReachedLoading: ref(true),
      companies: ref([]),
      columns: [
        {
          data: "name",
          defaultContent: "",
          orderData: [1],
          targets: [0],
          width: "30%",
          className: "align-middle",
          render: function (data, type, row, meta) {
            if (type === "display") {
              var url, style;
              if (row.logo) {
                if (isUrl(row.logo)) {
                  url = row.logo;
                } else {
                  url = new URL(`../assets/${row.logo}`, import.meta.url).href;
                }
                style =
                  "height:25px; width:25px; margin: 0 19px 0 0; border-radius: 50%; ";
              } else {
                url = new URL(`../assets/linkedin-company.svg`, import.meta.url)
                  .href;
                style =
                  "height:25px; width:25px; margin: 0 19px 0 0; border-radius: 50%;";
              }
              return (
                '<span class="d-flex align-items-center"><img src="' +
                url +
                '" style="' +
                style +
                '" /><span style="display:inline-block">' +
                data +
                "</span></span>"
              );
            }
          },
        },
        {
          data: "name",
          visible: false,
          searchable: false,
          targets: [1],
        },
        {
          data: "link",
          defaultContent: "-",
          width: "30%",
          className: "align-middle",
          orderData: [1],
          targets: [2],
          render: function (data, type, row, meta) {
            if (type === "display") {
              var url = new URL(`../assets/world-wide-web.png`, import.meta.url)
                .href;
              return (
                '<a href="' +
                data +
                '" target="_blank" style="background-color:rgba(10, 102, 194, 0.1); padding: 9px 25px; border-radius: 8px; display: inline-block;"><span class="d-flex align-items-center"> <img src="' +
                url +
                '" style="height:20px; width:20px; margin: 0 14px 0 0;" /><span style="display:inline-block">' +
                row.name +
                "</span></span></a>"
              );
            }
          },
        },
        {
          data: "impressions",
          defaultContent: "-",
          orderData: [4],
          targets: [3],
          className: "text-center align-middle",
          render: function (data, type, row, meta) {
            if (type === "display") {
              var impressions = data.toLocaleString(undefined, {
                maximumFractionDigits: 1,
              });
              return (
                '<div style="padding-right: 30px;">' + impressions + "</div>"
              );
            }
          },
        },
        {
          data: "impressions",
          visible: false,
          searchable: false,
          targets: [4],
        },
      ],
      keys: ["Name", "Name-Hidden", "Website", "Views", "Views-Hidden"],
      isLoading: ref(true),
      isTopRecordsLoading: ref(true),
      topIndustries: ref(null),
      topIndustriesChartData: ref(null),
      topJobTitles: ref(null),
      topJobTitlesChartData: ref(null),
      topRegions: ref(null),
      topRegionsChartData: ref(null),
      topCompanySizes: ref(null),
      topCompanySizesChartData: ref(null),
      chartOptions1: chartOptions1,
      chartOptions2: chartOptions2,
      chartOptions3: chartOptions3,
      chartOptions4: chartOptions4,
      datepicker,
      dateRange: ref([]),
      yesterday: yesterday,
      rangeType: ref("all"),
      rangeTypes: ref({
        yesterday: "Yesterday",
        last7: "Last 7 Days",
        last30: "Last 30 Days",
        thisMonth: "This Month",
        lastMonth: "Last Month",
        all: "All",
      }),
      startDate: ref(null),
      endDate: ref(null),
      showLeadIntro: ref(null),
      showTopIntro: ref(null),
    };
  },
  props: {
    propertyId: {
      type: String,
      required: true,
    },
    campaignId: {
      type: String,
      required: true,
    },
  },
  components: {
    PropertyDashboardSidebarNav,
    DatatableComponent,
    Bar,
    JsonCSV,
  },
  computed: {
    reachedCampaignsExport() {
      var results = [];
      if (this.companies) {
        this.companies.forEach((company) => {
          results.push({
            Name: company.name,
            "Company Website": company.link,
            Views: company.impressions,
            // Clicks: company.clicks,
          });
        });
      }
      return results;
    },
    campaignStartDate() {
      if (this.startDate) {
        return this.startDate;
      } else {
        return moment("2022-10-01").utc().toDate();
      }
    },
    isAllLoading() {
      return this.isTopRecordsLoading || this.isCompaniesReachedLoading;
    },
  },
  methods: {
    getCampaignInfo() {
      this.isLoading = true;
      var info = {
        campaignId: this.campaignId,
      };
      var _this = this;
      api()
        .getCampaignName(info)
        .then((res) => {
          if (res.data) {
            if (
              _this.campaignId == "652d4ce096d5ae0503069180" ||
              _this.campaignId == "685c4bdcb856f40bca877fdf"
            ) {
              _this.dateRange = [
                moment("2022-10-01").utc().format("YYYY-MM-DD HH:mm:ss"),
                moment("2023-02-28").utc().format("YYYY-MM-DD HH:mm:ss"),
              ];
            } else {
              var start = res.data.startDate
                ? moment(res.data.startDate).utc().format("YYYY-MM-DD HH:mm:ss")
                : moment("2022-10-01").utc().format("YYYY-MM-DD HH:mm:ss");
              var endDate = res.data.endDate
                ? moment(res.data.endDate).utc().format("YYYY-MM-DD HH:mm:ss")
                : _this.yesterday;
              _this.dateRange = [start, endDate];
              if (moment(start).utc().isSameOrAfter(moment(endDate).utc())) {
                _this.dateRange = [start, start];
              }
              _this.startDate = start;
              _this.endDate = endDate;
            }
            _this.campaignName = res.data.campaignName;
            var monthlyBudget = res.data.monthlyBudget;
            var showLeadContacts = res.data.showLeadContacts;
            var showTopContacts = res.data.showTopContacts;
            _this.showLeadIntro =
              !showLeadContacts && monthlyBudget && monthlyBudget < 1000;
            _this.showTopIntro =
              !showTopContacts && monthlyBudget && monthlyBudget < 1000;
            _this.isLoading = false;
          }
        });
    },
    getCompanyReachedReport() {
      this.isCompaniesReachedLoading = true;
      var _this = this;
      var info = {
        campaignId: this.campaignId,
      };
      if (this.dateRange.length > 0) {
        var startDate = moment(this.dateRange[0]).format("YYYY-MM-DD");
        var end = this.dateRange[1];
        if (!end) end = this.dateRange[0];
        var endDate = moment(end).format("YYYY-MM-DD");
        info.startDate = startDate;
        info.endDate = endDate;
      }

      api()
        .getTenantCompaniesData(info)
        .then((res) => {
          if (res.data) {
            _this.companies = res.data;
            _this.isCompaniesReachedLoading = false;
          }
        });
    },
    getTopRcordsReport() {
      this.isTopRecordsLoading = true;
      var _this = this;
      if (
        this.campaignId == "652d4ce096d5ae0503069180" ||
        this.campaignId == "685c4bdcb856f40bca877fdf"
      ) {
        _this.topIndustries = mockData.topIndustries;
        _this.topJobTitles = mockData.topJobTitles;
        _this.topRegions = mockData.topTenantMarkets;
        _this.topCompanySizes = mockData.topCompanySizes;
        _this.topIndustriesChartData = this.prepareChartData(
          _this.topIndustries,
          "#5B79BFD1"
        );
        _this.topJobTitlesChartData = this.prepareChartData(
          _this.topJobTitles,
          "#57A791D1"
        );
        _this.topRegionsChartData = this.prepareChartData(
          _this.topRegions,
          "#4550E9D1"
        );
        _this.topCompanySizesChartData = this.prepareChartData(
          _this.topCompanySizes,
          "#AA4465D1"
        );

        setTimeout(() => {
          _this.isTopRecordsLoading = false;
        }, 500);
      } else {
        var info = {
          campaignId: this.campaignId,
        };
        api()
          .getTopRcordsReport(info)
          .then((res) => {
            if (res.data) {
              _this.topIndustries = res.data.topIndustries;
              _this.topJobTitles = res.data.topJobTitles;
              _this.topRegions = res.data.topTenantMarkets;
              _this.topCompanySizes = res.data.topCompanySizes;
              _this.topIndustriesChartData = this.prepareChartData(
                _this.topIndustries,
                "#5B79BFD1"
              );
              _this.topJobTitlesChartData = this.prepareChartData(
                _this.topJobTitles,
                "#57A791D1"
              );
              _this.topRegionsChartData = this.prepareChartData(
                _this.topRegions,
                "#4550E9D1"
              );
              _this.topCompanySizesChartData = this.prepareChartData(
                _this.topCompanySizes,
                "#AA4465D1"
              );
              _this.isTopRecordsLoading = false;
            }
          });
      }
    },
    prepareChartData(rawData, backgroundColor) {
      var labels = rawData.map((item) => item.name);
      var data = rawData.map((item) => item.impressions);
      var chartData = {
        labels,
        datasets: [
          {
            label: "Impressions",
            data,
            backgroundColor: backgroundColor,
            borderWidth: 0,
            borderRadius: 10,
            borderSkipped: false,
            barThickness: 10,
          },
        ],
      };
      return chartData;
    },
    updateRange(type) {
      var yesterday = this.yesterday;
      this.rangeType = type;
      this.dateRangeLoading = true;
      switch (type) {
        case "yesterday":
          this.dateRange = [yesterday, yesterday];
          break;
        case "last7":
          this.dateRange = [
            moment(yesterday).subtract(6, "d").toDate(),
            yesterday,
          ];
          break;
        case "last30":
          this.dateRange = [
            moment(yesterday).subtract(29, "d").toDate(),
            yesterday,
          ];
          break;
        case "thisMonth":
          this.dateRange = [
            moment(yesterday).startOf("month").toDate(),
            yesterday,
          ];
          break;
        case "lastMonth":
          this.dateRange = [
            moment(yesterday).subtract(1, "months").startOf("month"),
            moment(yesterday).subtract(1, "months").endOf("month"),
          ];
          break;
        case "all":
          var start = this.startDate
            ? moment(this.startDate).format("YYYY-MM-DD HH:mm:ss")
            : moment("2022-10-01").utc().format("YYYY-MM-DD HH:mm:ss");
          var endDate = this.endDate
            ? moment(this.endDate).format("YYYY-MM-DD HH:mm:ss")
            : yesterday;
          this.dateRange = [start, endDate];
          break;
      }
      if (this.datepicker) {
        this.datepicker.closeMenu();
      }
    },
    generatePDF() {
      var campaignName = this.campaignName;
      var reportData = {
        campaignName: campaignName,
        topIndustries: this.topIndustriesChartData,
        topJobTitles: this.topJobTitlesChartData,
        topRegions: this.topRegionsChartData,
        topCompanySizes: this.topCompanySizesChartData,
        companies: this.companies
          .sort((a, b) => b.impressions - a.impressions)
          .slice(0, 15),
        dates:
          moment(this.dateRange[0]).format("MM/DD/YYYY") +
          " - " +
          moment(this.dateRange[1]).format("MM/DD/YYYY"),
      };
      var info = {
        reportData: reportData,
        templateName: "tenantDemographics",
      };
      api()
        .generateReportPDFNew(info)
        .then((response) => {
          if (response.data instanceof Blob) {
            const fileURL = URL.createObjectURL(response.data);
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              `${campaignName}-Tenant_Demographics.pdf`
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            URL.revokeObjectURL(fileURL);
          } else {
            console.error("Unexpected response data type:", response.data);
          }
        })
        .catch((error) => {
          console.error("PDF download failed:", error);
        });
    },
  },
  mounted() {
    this.getCampaignInfo();
    this.getTopRcordsReport();
    this.getCompanyReachedReport();
  },
  watch: {
    dateRange(newVal, oldVal) {
      if (oldVal.length > 0) {
        this.getCompanyReachedReport();
      }
      if (newVal && !newVal[1]) {
        this.dateRange[1] = this.dateRange[0];
      }
    },
  },
};
</script>